(function () {
  'use strict';

  if (window.__VENAT_CART_COUNT_SAFE__) return;
  window.__VENAT_CART_COUNT_SAFE__ = true;

  var refreshTimer = null;
  var I18N = window.VENAT_LOCALIZATION?.strings || {};

  function cartUrl() {
    if (window.routes && window.routes.cart_url) return window.routes.cart_url + '.js';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) return window.Shopify.routes.root + 'cart.js';
    return '/cart.js';
  }

  function cartLabel() { return I18N.cartLabel || 'Cart'; }
  function cartCountText(count) {
    var template = count === 1 ? (I18N.cartCountOne || '[count] item in cart') : (I18N.cartCountMany || '[count] items in cart');
    return template.replace('[count]', String(count));
  }

  function renderCount(cart) {
    var cartIcon = document.querySelector('#cart-icon-bubble');
    if (!cartIcon || !cart || typeof cart.item_count !== 'number') return;
    var count = cart.item_count;
    var bubble = cartIcon.querySelector('.cart-count-bubble');

    if (count <= 0) {
      if (bubble) bubble.remove();
      cartIcon.setAttribute('aria-label', cartLabel());
      return;
    }

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      cartIcon.appendChild(bubble);
    }

    var visible = bubble.querySelector('[aria-hidden="true"]');
    var hidden = bubble.querySelector('.visually-hidden');
    if (visible) visible.textContent = count < 100 ? String(count) : '99+';
    if (hidden) hidden.textContent = cartCountText(count);
    cartIcon.setAttribute('aria-label', cartLabel() + ' (' + count + ')');
    bubble.removeAttribute('hidden');
  }

  function refreshCount() {
    return fetch(cartUrl(), { method: 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Cart request failed'); return response.json(); })
      .then(renderCount)
      .catch(function (error) { console.error('VÉNAT cart count error:', error); });
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCount, 60);
  }

  function subscribeToDawn() {
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (event && event.cartData && typeof event.cartData.item_count === 'number') return renderCount(event.cartData);
          scheduleRefresh();
        });
      }
    } catch (error) {
      console.warn('VÉNAT cart count: Dawn subscription unavailable.', error);
    }
  }

  window.VenatCartCount = { render: renderCount, refresh: refreshCount, schedule: scheduleRefresh };

  function start() {
    subscribeToDawn();
    window.addEventListener('venat:cart-updated', function (event) {
      var cartData = event && event.detail && event.detail.cartData;
      if (cartData && typeof cartData.item_count === 'number') return renderCount(cartData);
      scheduleRefresh();
    });
    document.addEventListener('shopify:cart:lines-update', function (event) {
      var cartData = event && event.detail && event.detail.cart;
      if (cartData && typeof cartData.item_count === 'number') return renderCount(cartData);
      scheduleRefresh();
    });
    document.addEventListener('cart:updated', scheduleRefresh);
    document.addEventListener('cart:refresh', scheduleRefresh);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

/* VENAT_CART_BUNDLE_HOTFIX_20260912
   1) Makes Dawn/VÉNAT cart section parsing safe when the final line is removed.
   2) Makes VÉNAT bundle cards horizontally swipeable on mobile. */
(function () {
  'use strict';

  function installCartPatch() {
    try {
      if (typeof CartItems === 'undefined' || !CartItems.prototype || CartItems.prototype.__venatSafeSections) return false;
      CartItems.prototype.__venatSafeSections = true;
      CartItems.prototype.getSectionInnerHTML = function (html, selector) {
        if (!html) return '';
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        if (!selector) return parsed.body ? parsed.body.innerHTML : '';
        var source = parsed.querySelector(selector);
        return source ? source.innerHTML : '';
      };
      return true;
    } catch (error) {
      console.warn('VÉNAT cart safety patch:', error);
      return false;
    }
  }

  function installBundleSwipe() {
    if (!document.querySelector('.venat-bundle')) return;
    if (document.getElementById('venat-bundle-swipe-fix')) return;
    var style = document.createElement('style');
    style.id = 'venat-bundle-swipe-fix';
    style.textContent = '@media screen and (max-width:749px){.venat-bundle .venat-bundle__products{display:flex!important;grid-template-columns:none!important;gap:10px!important;overflow-x:auto!important;overflow-y:hidden!important;scroll-snap-type:x mandatory!important;overscroll-behavior-x:contain;-webkit-overflow-scrolling:touch;scrollbar-width:none;margin-left:-14px!important;margin-right:-14px!important;padding:24px 14px 8px!important;touch-action:pan-x pan-y}.venat-bundle .venat-bundle__products::-webkit-scrollbar{display:none!important}.venat-bundle .venat-bundle__product-wrap{flex:0 0 min(72vw,280px)!important;min-width:min(72vw,280px)!important;scroll-snap-align:start;scroll-snap-stop:normal}.venat-bundle .venat-bundle__product{width:100%}}';
    (document.body || document.head || document.documentElement).appendChild(style);
  }

  function startHotfix() {
    installBundleSwipe();
    if (!document.querySelector('cart-items, cart-drawer-items') || installCartPatch()) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (installCartPatch() || tries >= 12) clearInterval(timer);
    }, 150);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startHotfix, { once: true });
  else startHotfix();
})();

/* VÉNAT AI Skin Scan locale completion for Finnish and Dutch. */
(function () {
  'use strict';

  var locale = String(document.documentElement.lang || '').toLowerCase().split('-')[0];
  if (locale !== 'fi' && locale !== 'nl') return;

  var dictionaries = {
    fi: {
      hero_title: 'Anna ihosi ohjata rituaaliasi.', hero_text: 'Tunnista näkyviä ihon ominaisuuksia ja saat henkilökohtaisen kosmeettisen ihonhoitorutiinin.', start_title: 'Aloita ihoanalyysi', start_text: 'Käytä luonnonvaloa ja pidä kasvosi selvästi näkyvissä.', tip_light: 'Luonnonvalo', tip_filter: 'Ei suodatinta', tip_face: 'Koko kasvot näkyvissä', tip_expression: 'Neutraali ilme', use_camera: 'KÄYTÄ KAMERAA', upload_photo: 'LATAA KUVA', consent: 'Hyväksyn, että VÉNAT käsittelee tämän kuvan kosmeettista ihoanalyysiä varten.', take_photo: 'OTA KUVA', cancel: 'Peruuta', analyse: 'ANALYSOI IHONI', choose_other: 'Valitse toinen kuva', loading_title: 'Näkyviä ihon ominaisuuksia analysoidaan…', loading_text: 'Henkilökohtaista rutiiniasi luodaan.', profile_title: 'VÉNAT-ihoprofiilisi', analysis_title: 'Visuaalinen ihoanalyysisi', analysis_subtitle: 'Arvio perustuu kuvassa näkyviin ominaisuuksiin.', focus_title: 'Keskeiset huomioalueesi', routine_title: 'Suositeltu rutiinisi', products_title: 'VÉNAT-RUTIINISI', products_text: 'Suositeltuun rutiiniisi valitut tuotteet.', disclaimer: 'Kosmeettista ohjausta näkyvien ominaisuuksien perusteella. Tämä ei ole lääketieteellinen diagnoosi.', scan_again: 'Analysoi uudelleen', morning: 'Aamu', evening: 'Ilta', read_more: 'LUE LISÄÄ', consent_error: 'Hyväksy kuvan käsittely ennen jatkamista.', image_error: 'Valitse kelvollinen kuva.', large_error: 'Kuva on liian suuri. Valitse pienempi kuva.', camera_denied: 'Kameran käyttö estettiin. Salli kameran käyttö selaimen asetuksista.', camera_unavailable: 'Kamera ei ole käytettävissä. Lataa kuva sen sijaan.', camera_ready: 'Kamera ei ole vielä valmis. Odota hetki ja yritä uudelleen.', no_photo: 'Valitse ensin kuva.', no_endpoint: 'VÉNAT AI -moottoria ei ole yhdistetty.', invalid_server: 'AI-palvelin palautti virheellisen vastauksen.', analysis_error: 'Analyysiä ei voitu suorittaa. Yritä uudelleen selkeällä kuvalla luonnonvalossa.', confidence: 'Analyysin varmuus', caution: 'Tämä on varovainen visuaalinen arvio. Valaistus, ihonhoito ja kameran käsittely voivat vaikuttaa tulokseen.', no_focus: 'Kuvasta ei voitu määrittää selkeitä painopisteitä.'
    },
    nl: {
      hero_title: 'Laat je huid je ritueel leiden.', hero_text: 'Ontdek zichtbare huidkenmerken en ontvang een persoonlijke cosmetische huidverzorgingsroutine.', start_title: 'Start je huidanalyse', start_text: 'Gebruik natuurlijk licht en zorg dat je gezicht duidelijk zichtbaar is.', tip_light: 'Natuurlijk licht', tip_filter: 'Geen filter', tip_face: 'Volledig gezicht zichtbaar', tip_expression: 'Neutrale uitdrukking', use_camera: 'CAMERA GEBRUIKEN', upload_photo: 'FOTO UPLOADEN', consent: 'Ik geef toestemming aan VÉNAT om deze foto te verwerken voor deze cosmetische huidanalyse.', take_photo: 'FOTO MAKEN', cancel: 'Annuleren', analyse: 'ANALYSEER MIJN HUID', choose_other: 'Kies een andere foto', loading_title: 'Zichtbare huidkenmerken analyseren…', loading_text: 'Je persoonlijke routine wordt samengesteld.', profile_title: 'Jouw VÉNAT-huidprofiel', analysis_title: 'Jouw visuele huidanalyse', analysis_subtitle: 'Beoordeeld op basis van zichtbare kenmerken in je foto.', focus_title: 'Jouw aandachtspunten', routine_title: 'Jouw aanbevolen routine', products_title: 'JOUW VÉNAT-ROUTINE', products_text: 'Producten geselecteerd voor jouw aanbevolen routine.', disclaimer: 'Cosmetisch advies op basis van zichtbare kenmerken. Dit is geen medische diagnose.', scan_again: 'Opnieuw analyseren', morning: 'Ochtend', evening: 'Avond', read_more: 'LEES MEER', consent_error: 'Geef toestemming voor de verwerking van de foto voordat je verdergaat.', image_error: 'Kies een geldige afbeelding.', large_error: 'De afbeelding is te groot. Kies een kleinere foto.', camera_denied: 'Cameratoegang is geblokkeerd. Sta cameratoegang toe in je browserinstellingen.', camera_unavailable: 'De camera is niet beschikbaar. Upload in plaats daarvan een foto.', camera_ready: 'De camera is nog niet klaar. Wacht even en probeer opnieuw.', no_photo: 'Kies eerst een foto.', no_endpoint: 'De VÉNAT AI-engine is niet verbonden.', invalid_server: 'De AI-server gaf een ongeldig antwoord.', analysis_error: 'De analyse kon niet worden voltooid. Probeer opnieuw met een duidelijke foto in natuurlijk licht.', confidence: 'Zekerheid van de analyse', caution: 'Dit is een voorzichtige visuele schatting. Belichting, huidverzorging en cameraverwerking kunnen het resultaat beïnvloeden.', no_focus: 'Op basis van deze foto konden geen duidelijke aandachtspunten worden vastgesteld.'
    }
  };

  var t = dictionaries[locale];
  var englishErrors = {
    'Please give consent before continuing.': 'consent_error', 'Please choose a valid image.': 'image_error', 'The image is too large. Please choose a smaller photo.': 'large_error', 'Camera access was blocked. Please allow camera access in your browser settings.': 'camera_denied', 'The camera is not available. Please upload a photo instead.': 'camera_unavailable', 'The camera is not ready yet. Please wait a moment and try again.': 'camera_ready', 'Please choose a photo first.': 'no_photo', 'The VÉNAT AI engine is not connected.': 'no_endpoint', 'The AI server returned an invalid response.': 'invalid_server', 'The analysis could not be completed. Please try again with a clear photo in natural light.': 'analysis_error'
  };

  function patch(root) {
    if (!root) return;
    root.querySelectorAll('[data-i18n]').forEach(function (el) { var key = el.getAttribute('data-i18n'); if (t[key] && el.textContent !== t[key]) el.textContent = t[key]; });
    root.querySelectorAll('.vais__routine-box h4').forEach(function (el) { var text = el.textContent.trim(); if (text === 'Morning') el.textContent = t.morning; if (text === 'Evening') el.textContent = t.evening; });
    root.querySelectorAll('.vais__product-link').forEach(function (el) { if (el.textContent.trim() === 'READ MORE') el.textContent = t.read_more; });
    root.querySelectorAll('.vais__priority-empty').forEach(function (el) { if (el.textContent.trim() === 'No clear focus areas could be established from this photo.') el.textContent = t.no_focus; });
    var error = root.querySelector('[data-error]');
    if (error) { var errorKey = englishErrors[error.textContent.trim()]; if (errorKey && t[errorKey]) error.textContent = t[errorKey]; }
    var quality = root.querySelector('[data-quality-note]');
    if (quality && quality.textContent) {
      var current = quality.textContent.trim();
      if (current.indexOf('Analysis confidence:') === 0) {
        var match = current.match(/Analysis confidence:\s*([0-9]+)%/);
        quality.textContent = match ? t.confidence + ': ' + match[1] + '%. ' + t.caution : t.caution;
      } else if (current === 'This is a cautious visual estimate. Lighting, skincare and camera processing can affect it.') quality.textContent = t.caution;
    }
  }

  function init() {
    document.querySelectorAll('[data-venat-ai-scan]').forEach(function (root) {
      patch(root);
      var queued = false;
      var observer = new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; patch(root); });
      });
      observer.observe(root, { childList: true, subtree: true, characterData: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
